export const SERVER_URL = "https://do-calculate.com/api";
export const CopyRightDate = "2025";
export const AgeGregorian_EndPoint = "calculate-age-gregorian";
export const AgeHijri_EndPoint = "calculate-age-hijri";
export const DateGregorianDifferences_EndPoint =
  "calculate-date-gregorian-differences";
export const DateHijriDifferences_EndPoint = "calculate-date-hijri-differences";
export const BMI_EndPoint = "calculate-bmi";
export const BMI_Child_EndPoint = "calculate-child-bmi";
export const Calories_EndPoint = "calculate-calories";
export const BMR_EndPoint = "calculate-bmr";
export const IdealWeight_EndPoint = "calculate-ideal-weight";
export const BodyFat_EndPoint = "calculate-body-fat";
export const FoodEnergy_EndPoint = "calculate-food-energy";
export const Money_Zakat_EndPoint = "calculate-money-zakat";
export const Gold_Zakat_EndPoint = "calculate-gold-zakat";
export const Gold_Karat_EndPoint = "calculate-gold-karat";
export const Silver_Zakat_EndPoint = "calculate-silver-zakat";
export const Fruits_Zakat_EndPoint = "calculate-fruits-zakat";
export const Trade_Zakat_EndPoint = "calculate-trade-zakat";
export const Animals_Zakat_EndPoint = "calculate-animals-zakat";
export const Period_EndPoint = "calculate-period";
export const Conception_EndPoint = "calculate-conception";
export const Ovulation_EndPoint = "calculate-ovulation";
export const DueDate_EndPoint = "calculate-due-date";
export const PregnancyConception_EndPoint = "calculate-pregnancy-conception";
export const WeightGainPregnancyCalculate_EndPoint =
  "calculate-pregnancy-weight-gain";
export const PregnancyCalculate_EndPoint = "calculate-pregnancy";
export const CalculatorsType = {
  humanCalculators: 1,
  healthCalculators: 200,
  womenCalculators: 300,
  islamicCalculators: 400,
  mathCalculators: 500,
  studyCalculators: 600,
  physicsCalculators: 700,
  otherCalculators: 800,
  TimeArticles_Ar: 900,
  TimeArticles_En: 1000,
};
export const otherCalculators_EN = [
  {
    name: "Password Generator",
    link: "/calculator/en/random-password-generator/",
    description:
      "Password generator, strong passwords, account protection, data security, internet security, random password generator, letters, numbers, and symbols, personal account security, creating a strong password.",
    showMain: true,
  },
  {
    name: "Muslim Name Generator",
    link: "/calculator/en/random-name-generator/",
    description:
      "Use the name generator to discover a wide variety of unique and beautiful names. Whether you're looking for Arabic, Western, Islamic, Eastern, luxurious, or rare names, this generator provides diverse options to find the perfect name for your new baby!",
    showMain: true,
  },
  {
    name: "Random Number Generator",
    link: "/calculator/en/random-number-generator/",
    description:
      "Use the number generator to discover a wide variety of unique and beautiful numbers. Whether you're looking for Arabic, Western, Islamic, Eastern, luxurious, or rare numbers, this generator provides diverse options to find the perfect number for your new baby!",
    showMain: true,
  },
  {
    name: "Electronic Dhikr Counter (Tally Counter)",
    link: "/calculator/en/tally-counter/",
    description:
      "The electronic dhikr counter (tally counter) helps you keep track of your dhikr count easily and conveniently. You can use it to count your dhikr during prayers or any other time you wish to engage in remembrance of Allah. The counter is designed to be user-friendly and reliable, making your spiritual practice more focused and organized.",
    showMain: true,
  },
];
export const humanCalculators_En = [
  {
    name: "Gregorian Age Calculator",
    link: "/calculator/en/agegregorian/",
    description:
      "This calculator calculates age in years, months, and days using the Gregorian and Hijri calendar.",
    showMain: true,
  },
  {
    name: "Hijri Age Calculator",
    link: "/calculator/en/agehijri/",
    description:
      "Calculate your age in Hijri (Islamic) calendar by entering your birthdate in either Hijri or Gregorian date. Use the Hijri Age Calculator to convert dates into precise ages based on the Islamic calendar.",
    showMain: true,
  },
  {
    name: "Age Difference Calculator",
    link: "/calculator/en/gregoriandifferences/",
    description:
      "This calculator calculates the difference in age between two individuals using the Gregorian calendar.",
    showMain: true,
  },
  {
    name: "Gregorian Date Difference Calculator",
    link: "/calculator/en/dategregoriandifferences/",
    description:
      "This calculator is used to calculate the difference between two specific dates using the Gregorian calendar.",
    showMain: true,
  },
  {
    name: "Hijri Date Difference Calculator",
    link: "/calculator/en/datehijridifferences/",
    description:
      "This calculator calculates the difference between two specific dates using the Hijri calendar.",
    showMain: true,
  },
  {
    name: "Birthday Calculator",
    link: "/calculator/en/birthday/",
    description:
      "Use this calculator to find out the detailed time remaining until your birthday in the Gregorian calendar. Enter your birthday to get the difference between the current time and your birthday in months and days.",
    showMain: true,
  },
  {
    name: "Gregorian to Hijri Converter",
    link: "/calculator/en/gregorian_to_hijri/",
    description:
      "Convert date from Gregorian to Hijri by entering the Gregorian date and finding its equivalent in Hijri using the electronic date converter.",
    showMain: true,
  },
  {
    name: "Hijri to Gregorian Converter",
    link: "/calculator/en/hijri_to_gregorian/",
    description:
      "Convert date from Hijri to Gregorian by entering the Hijri date and finding its equivalent in Gregorian using the electronic date converter.",
  },
  {
    name: "Online Time Calculator",
    link: "/calculator/en/time-calculator/",
    description:
      "The free Time and Duration Calculator helps you add or subtract time values in terms of days, hours, minutes, or seconds with ease. You can also learn various concepts of time.",
  },
];
export const healthCalculators_En = [
  {
    name: "Calculate Body Mass Index (BMI) - Adults",
    link: "/calculator/en/bmiadults/",
    description:
      "This calculator calculates the Body Mass Index (BMI) for adults.",
    showMain: true,
  },
  {
    name: "Calculate Body Mass Index (BMI) - Children",
    link: "/calculator/en/bmichildren/",
    description:
      "This calculator is used to calculate the Body Mass Index (BMI) for children.",
    showMain: true,
  },
  {
    name: "Calorie Calculator",
    link: "/calculator/en/calories/",
    description:
      "This calculator calculates the daily calorie needs to maintain, gain, or lose weight.",
    showMain: true,
  },
  {
    name: "Calculate Basal Metabolic Rate (BMR)",
    link: "/calculator/en/bmr/",
    description:
      "This calculator calculates the Basal Metabolic Rate (BMR), which represents the calories your body needs at rest.",
    showMain: true,
  },
  {
    name: "Calculate Ideal Weight for Height",
    link: "/calculator/en/idealweight/",
    description:
      "This calculator helps in calculating the ideal weight that corresponds to your height.",
    showMain: true,
  },
  {
    name: "Calculate Body Fat Percentage",
    link: "/calculator/en/bodyfat/",
    description:
      "This calculator is used to calculate the body fat percentage based on certain measurements.",
    showMain: true,
  },
  {
    name: "Calculate Carbohydrates in the Body",
    link: "/calculator/en/carbohydrate/",
    description:
      "This calculator calculates the appropriate amount of carbohydrates to be consumed daily.",
    showMain: true,
  },
  {
    name: "Food Energy Unit Conversion Calculator",
    link: "/calculator/en/foodenergy/",
    description:
      "This calculator helps in converting between different food energy units such as calories, joules, and kilojoules.",
  },
  {
    name: "Protein Calculator",
    link: "/calculator/en/protein/",
    description:
      "Use the protein calculator to estimate the specified amount of protein to consume daily (grams/day) for weight loss and muscle gain.",
  },
  {
    name: "Healthy Sleep Calculator",
    link: "/calculator/en/sleep/",
    description:
      "Use this calculator to calculate the right time to go to bed or wake up so you can wake up refreshed between sleep cycles.",
  },
];
export const financialCalculators_En = [
  {
    name: "Price-to-Earnings (P/E) Ratio Calculator",
    link: "/calculator/en/pe-ratio/",
    description:
      "The Price-to-Earnings (P/E) Ratio Calculator calculates the P/E ratio for companies based on the market value of the stock and earnings per share.",
    showMain: true,
  },
  {
    name: "Inflation Impact Calculator",
    link: "/calculator/en/inflation/",
    description:
      "The Inflation Impact Calculator calculates the amount of money that loses its value due to inflation between two different time periods.",
    showMain: true,
  },
  {
    name: "AdSense Calculator",
    link: "/calculator/en/google-adsense/",
    description:
      "Free Google AdSense revenue calculator - find out how much money your website can make. This tool uses data from Google.",
    showMain: true,
  },
  {
    name: "VAT Calculator",
    link: "/calculator/en/vat/",
    description:
      "Calculate VAT rates in the UK with our free online VAT calculator. Easily determine VAT amounts for your transactions.",
    showMain: true,
  },
];
export const womenCalculators_En = [
  {
    name: "Menstrual Cycle Calculator",
    link: "/calculator/en/period/",
    description:
      "This calculator helps track the menstrual cycle and determine fertile periods.",
    showMain: true,
  },
  {
    name: "Pregnancy Calculator",
    link: "/calculator/en/pregnancy/",
    description:
      "This calculator is used to calculate the due date of pregnancy and estimate the current week of pregnancy.",
    showMain: true,
  },
  {
    name: "Pregnancy Conception Date Calculator",
    link: "/calculator/en/pregnancy-conception/",
    description:
      "This calculator calculates the conception date during pregnancy.",
    showMain: true,
  },
  {
    name: "Estimated Due Date Calculator",
    link: "/calculator/en/pregnancy-due-date/",
    description:
      "This calculator is used to estimate the expected due date based on the pregnancy start date.",
    showMain: true,
  },
  {
    name: "Ovulation Date Calculator",
    link: "/calculator/en/ovulation/",
    description:
      "This calculator helps estimate the ovulation date and the best time for conception.",
    showMain: true,
  },
  {
    name: "Conception Date Calculator",
    link: "/calculator/en/conception/",
    description:
      "This calculator is used to calculate the conception date based on your menstrual cycle and cycle duration.",
    showMain: true,
  },
];
export const islamicCalculators_En = [
  {
    name: "Wealth Zakat Calculator",
    link: "/calculator/en/money-zakat/",
    description:
      "This calculator is used to calculate wealth Zakat and alms based on Islamic rules.",
    showMain: true,
  },
  {
    name: "Gold Zakat Calculator",
    link: "/calculator/en/gold-zakat/",
    description:
      "This calculator calculates gold Zakat and jewelry based on Shariah conditions.",
    showMain: true,
  },
  {
    name: "Silver Zakat Calculator",
    link: "/calculator/en/silver-zakat/",
    description:
      "This calculator is used to calculate silver and precious metals Zakat based on Islamic rulings.",
    showMain: true,
  },
  {
    name: "Fruits Zakat Calculator",
    link: "/calculator/en/fruits-zakat/",
    description:
      "This calculator calculates Zakat on fruits and agricultural produce according to religious rules.",
    showMain: true,
  },
  {
    name: "Trade Zakat Calculator",
    link: "/calculator/en/trade-zakat/",
    description:
      "This calculator is used to calculate trade assets and investment capital Zakat.",
    showMain: true,
  },
  {
    name: "Animal Zakat Calculator",
    link: "/calculator/en/animals-zakat/",
    description:
      "This calculator calculates Zakat on animals and livestock based on Shariah rules.",
    showMain: true,
  },
  {
    name: "Gold Karat Conversion Calculator",
    link: "/calculator/en/gold-karat/",
    description:
      "This calculator is used to convert gold karat units into other units such as grams and ounces.",
    showMain: true,
  },
];
export const comingSoon_En = [{ name: "Coming Soon", link: "#" }];
export const mathCalculators_En = [
  {
    name: "Percentage Calculator",
    link: "/calculator/en/percentage/",
    description:
      "This calculator is used to calculate percentages and percentage increase or decrease.",
    showMain: true,
  },
  {
    name: "Volume Calculator",
    link: "/calculator/en/volumes/",
    description:
      "This free calculator calculates volumes of common shapes including sphere, cone, cube, cylinder, capsule, cap, frustum cone, ellipsoid, pyramid, tube, and more.",
    showMain: true,
  },
  {
    name: "Root Calculator",
    link: "/calculator/en/roots/",
    description:
      "This free calculator computes roots for numbers, including common roots like square root or cubic root, and calculates the root for any given number.",
    showMain: true,
  },
  {
    name: "Area Calculator",
    link: "/calculator/en/areas/",
    description:
      "This calculator calculates the area of various common geometric shapes, including rectangle, triangle, parallelogram, circle, sector, and ellipse.",
    showMain: true,
  },
  {
    name: "Median Rank Calculator",
    link: "/calculator/en/median/",
    description:
      "The median value calculator calculates the median rank and explains how to calculate it.",
    showMain: true,
  },
  {
    name: "Cylinder Circumference Calculator",
    link: "/calculator/en/cylinder-circumference/",
    description:
      "The cylinder circumference calculator calculates the circumference of a cylinder based on its diameter and height.",
    showMain: true,
  },
  {
    name: "Tank Area Calculator",
    link: "/calculator/en/tank-area/",
    description:
      "The tank area calculator calculates the area of a tank based on its dimensions and the rectangles that make up the tank.",
    showMain: true,
  },
  {
    name: "Square Side Length Calculator",
    link: "/calculator/en/square-side-length/",
    description:
      "The square side length calculator calculates the side length of a square based on the input area or perimeter.",
  },
  {
    name: "Absence Percentage Calculator",
    link: "/calculator/en/absence-percentage/",
    description:
      "The absence percentage calculator calculates the absence percentage based on the total attendance and absence count.",
  },
  {
    name: "Attendance Percentage Calculator",
    link: "/calculator/en/attendance-percentage/",
    description:
      "The attendance percentage calculator calculates the attendance percentage based on the total attendance and absence count.",
  },
  {
    name: "Population Density Calculator",
    link: "/calculator/en/population-density/",
    description:
      "The population density calculator calculates population density based on the population count and area.",
  },
  {
    name: "Success and Failure Rate Calculator",
    link: "/calculator/en/success-failure-rate/",
    description:
      "The success and failure rate calculator calculates success and failure rates based on the number of successes and total attempts.",
  },
  {
    name: "One-Fifth Calculator",
    link: "/calculator/en/one-fifth/",
    description:
      "The one-fifth calculator calculates one-fifth of a total amount based on the input amount.",
  },
  {
    name: "Circle Radius Calculator",
    link: "/calculator/en/circle-radius/",
    description:
      "The circle radius calculator calculates the radius of a circle using information such as the diameter, circumference, or area of the circle.",
  },
  {
    name: "Percentage List for Any Number from 1 to 100",
    link: "/calculator/en/percentage_converter/percentage_list/",
    description:
      "'percentage calculator, calculate percentage, percentage tool, percentage, calculate numbers, numbers from 1 to 100",
  },
  {
    name: "5% of Amount Calculator",
    link: "/calculator/en/5percent/",
    description:
      "Learn how to calculate 5% of an amount. This calculator calculates the value and percentage of 5% of a specific amount.",
  },
  {
    name: "10% of Amount Calculator",
    link: "/calculator/en/10percent/",
    description:
      "Learn how to calculate 10% of an amount. This calculator calculates the value and percentage of 10% of a specific amount.",
  },
  {
    name: "15% of Amount Calculator",
    link: "/calculator/en/15percent/",
    description:
      "Learn how to calculate 15% of an amount. This calculator calculates the value and percentage of 15% of a specific amount.",
  },
  {
    name: "20% of Amount Calculator",
    link: "/calculator/en/20percent/",
    description:
      "Learn how to calculate 20% of an amount. This calculator calculates the value and percentage of 20% of a specific amount.",
  },
  {
    name: "25% of Amount Calculator",
    link: "/calculator/en/25percent/",
    description:
      "Learn how to calculate 25% of an amount. This calculator calculates the value and percentage of 25% of a specific amount.",
  },
  {
    name: "30% of Amount Calculator",
    link: "/calculator/en/30percent/",
    description:
      "Learn how to calculate 30% of an amount. This calculator calculates the value and percentage of 30% of a specific amount.",
  },
  {
    name: "35% of Amount Calculator",
    link: "/calculator/en/35percent/",
    description:
      "Learn how to calculate 35% of an amount. This calculator calculates the value and percentage of 35% of a specific amount.",
  },
  {
    name: "40% of Amount Calculator",
    link: "/calculator/en/40percent/",
    description:
      "Learn how to calculate 40% of an amount. This calculator calculates the value and percentage of 40% of a specific amount.",
  },
  {
    name: "75% of Amount Calculator",
    link: "/calculator/en/75percent/",
    description:
      "Learn how to calculate 75% of an amount. This calculator calculates the value and percentage of 75% of a specific amount.",
  },
  {
    name: "One-Fifth Calculator",
    link: "/calculator/en/one-fifth/",
    description:
      "The one-fifth calculator calculates one-fifth of a total amount based on the input amount.",
  },
];
export const studyCalculators_En = [
  {
    name: "GPA Table Converter",
    link: "/calculator/en/gpatableconverter/",
    description:
      "This calculator helps convert students cumulative GPA to different scales, such as GPA, percentage system, and more.",
    showMain: true,
  },
  {
    name: "International University Grade Calculator",
    link: "/calculator/en/gpagrade/",
    description:
      "This calculator calculates the university grade based on the international grading system.",
    showMain: true,
  },
  {
    name: "GPA Calculator on a 4.0 Scale",
    link: "/calculator/en/gpa4/",
    description:
      "Use this calculator to calculate the cumulative GPA based on a 4.0 grading system.",
    showMain: true,
  },
  {
    name: "GPA Calculator on a 5.0 Scale",
    link: "/calculator/en/gpa5/",
    description:
      "This calculator calculates the cumulative GPA based on a 5.0 grading system.",
    showMain: true,
  },
  {
    name: "Grade to Percentage Converter",
    link: "/calculator/en/grade100/",
    description:
      "This calculator converts grades from the grading system to the percentage system.",
    showMain: true,
  },
  {
    name: "GPA Planning Calculator",
    link: "/calculator/en/gpaplanner/",
    description:
      "Use this calculator to plan your future cumulative GPA based on expected grades.",
    showMain: true,
  },
  {
    name: "Grade Conversion Between 100 and 4 Scales",
    link: "/calculator/en/grade100to4/",
    description:
      "This calculator helps convert grades between the percentage system and the 4.0 grading scale and vice versa.",
    showMain: true,
  },
  {
    name: "Convert GPA from 5 to 100 and Vice Versa",
    link: "/calculator/en/grade100to5/",
    description:
      "Easily convert your cumulative GPA between the 5-point and 100-point systems. Learn how to convert your GPA from 5 to 100 and vice versa using this simple tool.",
  },
  {
    name: "GPA Converter: 4.0 Scale to 5.0 Scale and Vice Versa",
    link: "/calculator/en/gpa4to5/",
    description:
      "Use this calculator to convert cumulative GPA between the 4.0 and 5.0 grading scales.",
  },
  {
    name: "Test Grade Calculator",
    link: "/calculator/en/test-grade/",
    description:
      "Easily calculate your test score and grade using the advanced grade calculator. Get the percentage and letter grade based on the number of points and incorrect answers.",
  },
  {
    name: "Conversion to the British Grading System",
    link: "/calculator/en/gradetouk/",
    description:
      "This calculator converts cumulative GPA to the British grading system.",
  },
  {
    name: "Convert University GPA to the German System",
    link: "/calculator/en/gradetogerman/",
    description:
      "Easily and accurately convert your university GPA to the German system. Learn how to convert your Bachelor's and Master's GPA to the German system using this useful tool.",
  },
  {
    name: "Convert University GPA to the French System",
    link: "/calculator/en/gradetofrench/",
    description:
      "Discover how to easily and accurately convert your university GPA to the French system. Learn the details of the French university grading system.",
  },
  {
    name: "Convert University GPA to the Canadian System",
    link: "/calculator/en/gradetocanada/",
    description:
      "Discover how to easily and accurately convert your university GPA to the Canadian system. Learn the details of the Canadian university grading system.",
  },
  {
    name: "Convert University GPA to the Malaysian Grading System",
    link: "/calculator/en/gradetomalaysia/",
    description:
      "Learn how to easily and accurately convert your cumulative GPA to the Malaysian grading system. Get to know the grading system in Malaysian universities.",
  },
  {
    name: "Convert Cumulative GPA to the Turkish System",
    link: "/calculator/en/gradetoturkey/",
    description:
      "Discover how to easily and accurately convert your university GPA to the Turkish system. Learn the details of the Turkish university grading system.",
  },
  {
    name: "Convert Cumulative GPA to the Australian System",
    link: "/calculator/en/gradetoaustralia/",
    description:
      "Discover how to easily and accurately convert your university GPA to the Australian system. Learn the details of the Australian university grading system.",
  },
];
export const physicsCalculators_En = [
  {
    name: "Arrival Time Calculator",
    link: "/calculator/en/arrivaltime/",
    description:
      "The Arrival Time Calculator calculates the time it takes for a person, vehicle, or moving object to reach a destination based on speed and distance.",
    showMain: true,
  },
  {
    name: "Cubic Meter Calculator",
    link: "/calculator/en/cubicmeter/",
    description:
      "This calculator computes the cubic meter - electronic cubic meter calculator - learn how to calculate the cubic meter.",
    showMain: true,
  },
  {
    name: "Lens Power Calculator",
    link: "/calculator/en/lenspower/",
    description:
      "The Electronic Lens Power Calculator accurately calculates the eye diopter power quickly and precisely.",
    showMain: true,
  },
  {
    name: "Gas Volume Calculator",
    link: "/calculator/en/gasvolume/",
    description:
      "This calculator easily calculates gas volume and clarifies the steps required to compute it.",
    showMain: true,
  },
  {
    name: "Electric Charge Calculator",
    link: "/calculator/en/electric-charge/",
    description:
      "The Electric Charge Calculator calculates the electric charge value based on the force between two charged bodies.",
    showMain: true,
  },
  {
    name: "Velocity Calculator",
    link: "/calculator/en/velocity/",
    description:
      "The Velocity Calculator calculates velocity based on distance and time.",
    showMain: true,
  },
  {
    name: "Acceleration Calculator",
    link: "/calculator/en/acceleration/",
    description:
      "The Acceleration Calculator calculates acceleration based on changes in speed and time.",
    showMain: true,
  },
  {
    name: "Photon Energy Calculator",
    link: "/calculator/en/photonenergy/",
    description:
      "The Photon Energy Calculator calculates photon energy based on photon frequency and Planck's constant.",
  },
  {
    name: "Friction Force Calculator",
    link: "/calculator/en/frictionforce/",
    description:
      "The Friction Force Calculator calculates frictional force based on acceleration and mass.",
  },
  {
    name: "Engine Horsepower Calculator ",
    link: "/calculator/en/horsepower/",
    description:
      "Use the Engine Horsepower Calculator to estimate the power of your vehicle's engine. Enter key details and get accurate results.",
  },
];
export const chemistryCalculators_En = [
  {
    name: "Iron Mass Calculator",
    link: "/calculator/en/iron-mass/",
    description:
      "The Iron Mass Calculator calculates the mass of an iron piece based on the entered dimensions.",
    showMain: true,
  },
  {
    name: "Water Mass Calculator",
    link: "/calculator/en/water-mass/",
    description:
      "The Water Mass Calculator calculates the mass of water based on volume and water density.",
    showMain: true,
  },
  {
    name: "Molar Mass Calculator",
    link: "/calculator/en/molar-mass/",
    description:
      "All substances are made up of atoms or molecules. In chemistry, it is crucial to accurately measure their quantities. To determine the number of reactants and products of chemical reactions, we use the SI base unit of the mole, the symbol mol.",
    showMain: true,
  },
];
export const TimeArticles_En = [
  {
    name: "Remaining Days until Ramadan 2025",
    link: "/articles-en/ramadan/",
    description:
      "When is the first day of Ramadan 2025 in the Hijri and Gregorian calendars - When does Ramadan start - Countdown to the month of Ramadan - How many days left until the beginning of the blessed month of Ramadan.",
  },
  {
    name: "Remaining Days until Eid al-Adha 2025",
    link: "/articles-en/eid-adha/",
    description:
      "Here you will find the countdown to Eid al-Adha, where you can find out how many days are left until Eid al-Adha.",
  },
  {
    name: "Remaining Days until Eid al-Fitr 2025",
    link: "/articles-en/eid-fatr/",
    description:
      "Here you will find the countdown to Eid al-Fitr, where you can find out how many days are left until Eid al-Fitr.",
  },
];
